import { render, staticRenderFns } from "./bookshelfIndex.vue?vue&type=template&id=212f1d2e&scoped=true"
import script from "./bookshelfIndex.vue?vue&type=script&lang=js"
export * from "./bookshelfIndex.vue?vue&type=script&lang=js"
import style0 from "./bookshelfIndex.vue?vue&type=style&index=0&id=212f1d2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f1d2e",
  null
  
)

export default component.exports